// extracted by mini-css-extract-plugin
module.exports = {"sticky":"timeout_alert_sticky__2ZPMP"};